const GA_MEASUREMENT_ID = "G-3L65TV4DV2";

export const trackEvent = (eventName, parameters = {}) => {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;

  window.gtag("event", eventName, {
    ...parameters,
    send_to: GA_MEASUREMENT_ID,
  });
};

export const trackPageView = (location) => {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;

  const pagePath = `${location.pathname}${location.search}${location.hash}`;
  window.gtag("event", "page_view", {
    send_to: GA_MEASUREMENT_ID,
    page_title: document.title,
    page_location: window.location.href,
    page_path: pagePath,
  });
};
